import { FieldItem } from 'models';

interface BuildingsFields {
  baseInfo: FieldItem;
  sizeInfo: FieldItem;
  locationInfo: FieldItem;
  otherInfo: FieldItem;
}

// id - field path
// format - string, date, boolean
// options (include when format is boolean) - [true, false]

export const buildingsFields: BuildingsFields = {
  baseInfo: {
    title: 'G_GeneralInformation',
    fieldsList: [
      {
        id: 'Name',
        format: 'string',
        key: 'BuildingName',
      },
      {
        id: 'ConstructionCompletionYear',
        format: 'string',
        key: 'Valmistumisvuosi',
      },
      {
        id: 'BuildingType.Label',
        format: 'string',
        key: 'BuildingTypeLabel',
      },
      {
        id: 'Description',
        format: 'string',
        key: 'BuildingDescription',
      },
    ],
  },
  locationInfo: {
    title: 'G_LocationInformation',
    fieldsList: [
      {
        id: 'StreetAddress',
        format: 'string',
        key: 'StreetAddress',
      },
      {
        id: 'PostalArea',
        format: 'string',
        key: 'PostalArea',
      },
      {
        id: 'PostalCode',
        format: 'string',
        key: 'PostalCode',
      },
    ],
  },
  sizeInfo: {
    title: 'G_SizeInformation',
    fieldsList: [
      {
        id: 'VolumeCubicMetersTotal',
        format: 'string',
        key: 'VolumeCubicMetersTotal',
      },
      {
        id: 'FloorsNumberOf',
        format: 'string',
        key: 'FloorsNumberOf',
      },
      {
        id: 'StairwaysNumberOf',
        format: 'string',
        key: 'StairwaysNumberOf',
      },
      {
        id: 'BuildingRightUsed',
        format: 'string',
        key: 'BuildingRightUsed',
      },
      {
        id: 'BuildingRightFloorSpaceUsed',
        format: 'string',
        key: 'BuildingRightFloorSpaceUsed',
      },
    ],
  },
  otherInfo: {
    title: 'G_OtherInformation',
    fieldsList: [
      {
        id: 'HeatingEnergyType.Label',
        format: 'string',
        key: 'HeatingEnergyTypeLabel',
      },
      {
        id: 'HeatingSystemType.Name',
        format: 'string',
        key: 'HeatingSystemTypName',
      },
      {
        id: 'AirConditioningSystemType.Name',
        format: 'string',
        key: 'AirConditioningSystemTypeName',
      },
      {
        id: 'CommunicationNetworkProvider.Name',
        format: 'string',
        key: 'CommunicationNetworkProviderName',
      },
      {
        id: 'CommunicationNetworkType.Name',
        format: 'string',
        key: 'CommunicationNetworkTypeName',
      },
      {
        id: 'CoolingSystemType.Label',
        format: 'string',
        key: 'CoolingSystemTypeLabel',
      },
      {
        id: 'TVAntennaSystemType.Name',
        format: 'string',
        key: 'TVAntennaSystemTypeName',
      },
      {
        id: 'TVAntennaSystemProvider.Name',
        format: 'string',
        key: 'TVAntennaSystemProviderName',
      },
    ],
  },
};
